(function () {
  'use strict';

  var VERSION = '2026-08-23.1';
  var ATTRIBUTION_KEY = 'bps_article_attribution';
  var VIEW_KEY_PREFIX = 'bps_article_viewed:';
  var ATTRIBUTION_TTL_MS = 2 * 60 * 60 * 1000;
  var BRIDGE_SELECTOR = '[data-bps-commercial-bridge]';

  function safeText(value, maxLength) {
    return String(value || '')
      .replace(/\s+/g, ' ')
      .trim()
      .slice(0, maxLength || 160);
  }

  function safePath(value) {
    try {
      var url = new URL(value, window.location.origin);
      return url.origin === window.location.origin ? url.pathname : '';
    } catch (error) {
      return '';
    }
  }

  function slug(value) {
    return safeText(value, 80)
      .toLowerCase()
      .replace(/[^a-z0-9]+/g, '_')
      .replace(/^_+|_+$/g, '')
      .slice(0, 48);
  }

  function readAttribution() {
    try {
      var value = JSON.parse(window.sessionStorage.getItem(ATTRIBUTION_KEY) || 'null');
      if (!value || !value.created_at || Date.now() - Date.parse(value.created_at) > ATTRIBUTION_TTL_MS) {
        window.sessionStorage.removeItem(ATTRIBUTION_KEY);
        return null;
      }
      return value;
    } catch (error) {
      return null;
    }
  }

  function writeAttribution(value) {
    try {
      window.sessionStorage.setItem(ATTRIBUTION_KEY, JSON.stringify(value));
    } catch (error) {
      // Measurement must never block navigation or commerce.
    }
  }

  function publishEvent(name, data, retry) {
    var analytics = window.Shopify && window.Shopify.analytics;
    if (analytics && typeof analytics.publish === 'function') {
      try {
        Promise.resolve(analytics.publish(name, data)).catch(function () {});
        return;
      } catch (error) {
        // Retry once below if Shopify's analytics runtime is still loading.
      }
    }
    if (retry !== false) {
      window.setTimeout(function () {
        publishEvent(name, data, false);
      }, 800);
    }
  }

  function eventData(attribution, extra) {
    return Object.assign(
      {
        measurement_version: VERSION,
        article_path: attribution.source_path,
        article_title: attribution.source_title,
        destination_path: attribution.destination_path,
        bridge_action: attribution.action,
        locale: attribution.locale
      },
      extra || {}
    );
  }

  function updateCartAttribution(attribution, actionOverride) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var endpoint = root.replace(/\/?$/, '/') + 'cart/update.js';
    var attributes = {
      bps_article_source__: attribution.source_path,
      bps_bridge_action__: actionOverride || attribution.action,
      bps_bridge_destination__: attribution.destination_path,
      bps_bridge_started_at__: attribution.created_at
    };

    try {
      window.fetch(endpoint, {
        method: 'POST',
        credentials: 'same-origin',
        keepalive: true,
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: attributes })
      }).catch(function () {});
    } catch (error) {
      // Attribution is supplementary and must not interrupt the buyer.
    }
  }

  function classifyLink(link) {
    var path = safePath(link.href);
    if (!path) return 'external';
    if (/\/pages\/subscribe\/?$/.test(path)) return 'newsletter';
    if (/mail-in-film-development|package-film-rolls-shipping/.test(path)) return 'mail_in';
    if (/\/products\//.test(path)) return 'product';
    if (/film-scanning|scan-your-film/.test(path)) return 'scanning';
    if (/film-development|develop-and-scan|c-41|ecn-2|black-and-white|e-6/.test(path)) return 'development';
    if (/film-problems-negative-diagnosis|diagnos/.test(path)) return 'diagnosis';
    if (/checklist|airport-security-card|film-storage/.test(path)) return 'resource';
    return 'internal';
  }

  function attributionForLink(link) {
    return {
      source_path: window.location.pathname,
      source_title: safeText((document.querySelector('h1') || {}).textContent, 120),
      destination_path: safePath(link.href),
      destination_label: safeText(link.textContent || link.getAttribute('aria-label'), 100),
      action: classifyLink(link),
      locale: safeText(document.documentElement.lang, 12),
      created_at: new Date().toISOString()
    };
  }

  function onBridgeClick(event) {
    var link = event.target.closest && event.target.closest(BRIDGE_SELECTOR + ' a[href]');
    if (!link) return;
    var attribution = attributionForLink(link);
    writeAttribution(attribution);
    updateCartAttribution(attribution);
    publishEvent('bps:article_bridge_click', eventData(attribution, {
      destination_label: attribution.destination_label
    }));
  }

  function ensureHiddenInput(form, name, value) {
    var input = form.querySelector('input[name="' + name + '"]');
    if (!input) {
      input = document.createElement('input');
      input.type = 'hidden';
      input.name = name;
      form.appendChild(input);
    }
    input.value = value;
  }

  function annotateProductForms(attribution) {
    if (!attribution || !/\/products\//.test(window.location.pathname)) return;
    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      ensureHiddenInput(form, 'properties[_bps_article_source]', attribution.source_path);
      ensureHiddenInput(form, 'properties[_bps_bridge_action]', attribution.action);
      ensureHiddenInput(form, 'properties[_bps_bridge_destination]', attribution.destination_path);
    });
  }

  function tagNewsletterForm(attribution) {
    if (!attribution || !/\/pages\/subscribe\/?$/.test(window.location.pathname)) return;
    var form = document.querySelector('#BpsNewsletter form');
    if (!form) return;
    var tags = form.querySelector('input[name="contact[tags]"]');
    if (!tags) {
      tags = document.createElement('input');
      tags.type = 'hidden';
      tags.name = 'contact[tags]';
      form.appendChild(tags);
    }
    var existing = tags.value ? tags.value.split(',').map(function (tag) { return tag.trim(); }) : [];
    var sourceTag = 'bps_article_' + slug(attribution.source_path.split('/').pop());
    var resourceTag = 'bps_resource_' + slug(attribution.action);
    [sourceTag, resourceTag].forEach(function (tag) {
      if (tag && existing.indexOf(tag) === -1) existing.push(tag);
    });
    tags.value = existing.filter(Boolean).join(',');
    form.dataset.bpsArticleSource = attribution.source_path;
  }

  function publishDestinationView(attribution) {
    if (!attribution || window.location.pathname === attribution.source_path) return;
    var key = VIEW_KEY_PREFIX + window.location.pathname;
    try {
      if (window.sessionStorage.getItem(key) === attribution.created_at) return;
      window.sessionStorage.setItem(key, attribution.created_at);
    } catch (error) {
      // Continue; duplicate suppression is optional.
    }
    publishEvent('bps:article_destination_view', eventData(attribution, {
      viewed_path: window.location.pathname
    }));
  }

  function onSubmit(event) {
    var attribution = readAttribution();
    if (!attribution) return;
    var form = event.target;

    if (form.matches && form.matches('form[action*="/cart/add"]')) {
      annotateProductForms(attribution);
      updateCartAttribution(attribution, 'add_to_cart_intent');
      publishEvent('bps:article_add_to_cart_intent', eventData(attribution, {
        product_path: window.location.pathname
      }));
    }

    if (form.matches && form.matches('#BpsNewsletter form')) {
      tagNewsletterForm(attribution);
      publishEvent('bps:article_newsletter_submit', eventData(attribution));
    }
  }

  function onCheckoutClick(event) {
    var attribution = readAttribution();
    if (!attribution) return;
    var control = event.target.closest && event.target.closest('a[href*="/checkout"], button[name="checkout"], input[name="checkout"]');
    if (!control) return;
    updateCartAttribution(attribution, 'checkout_intent');
    publishEvent('bps:article_checkout_intent', eventData(attribution));
  }

  function initialise() {
    var attribution = readAttribution();
    annotateProductForms(attribution);
    tagNewsletterForm(attribution);
    publishDestinationView(attribution);

    document.addEventListener('click', onBridgeClick, true);
    document.addEventListener('click', onCheckoutClick, true);
    document.addEventListener('submit', onSubmit, true);

    if (attribution && /\/products\//.test(window.location.pathname) && window.MutationObserver) {
      new MutationObserver(function () {
        annotateProductForms(attribution);
      }).observe(document.body, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialise, { once: true });
  } else {
    initialise();
  }
})();
